import ChangeLogModal from "./modals/change-log-modal/change-log-modal";
import DisableSiteModal from "./modals/disable-site-modal/disable-site-modal";
import EditSiteModal from "./modals/edit-site-modal/edit-site-modal";
import ExportSiteReportModal from "./modals/export-site-report-modal/export-site-report-modal";
import { ISiteViewModel } from "./view-site-helpers";

interface ViewSiteModalsProps {
  plantId: string;
  site: ISiteViewModel;
  showDisableSiteModal: boolean;
  showEditSiteModal: boolean;
  showChangeLogModal: boolean;
  showExportSiteReportModal: boolean;
  isLoadingChangeSolarPlantStatus: boolean;
  onCloseDisable: () => void;
  onCloseEdit: () => void;
  onCloseChangeLog: () => void;
  onCloseExport: () => void;
  onDisableConfirm: () => void;
  onEditSuccess: () => void;
  onChangeLogSuccess: () => void;
}

const ViewSiteModals = ({
  plantId,
  site,
  showDisableSiteModal,
  showEditSiteModal,
  showChangeLogModal,
  showExportSiteReportModal,
  isLoadingChangeSolarPlantStatus,
  onCloseDisable,
  onCloseEdit,
  onCloseChangeLog,
  onCloseExport,
  onDisableConfirm,
  onEditSuccess,
  onChangeLogSuccess,
}: ViewSiteModalsProps) => {
  return (
    <>
      <DisableSiteModal
        show={showDisableSiteModal}
        onClose={onCloseDisable}
        onCancel={onCloseDisable}
        siteName={site.originalName}
        onConfirm={onDisableConfirm}
        isLoading={isLoadingChangeSolarPlantStatus}
        isActive={site.isActive}
      />
      <EditSiteModal
        show={showEditSiteModal}
        plantId={plantId}
        initialSiteName={site.originalName}
        initialSiteAlias={site.siteAlias}
        initialAddress={site.address}
        initialLatitude={site.latitude}
        initialLongitude={site.longitude}
        initialCapacity={site.capacity}
        onClose={onCloseEdit}
        onCancel={onCloseEdit}
        onSuccess={onEditSuccess}
      />
      <ChangeLogModal
        show={showChangeLogModal}
        plantId={plantId}
        changelogs={site.changelog}
        onClose={onCloseChangeLog}
        onCancel={onCloseChangeLog}
        onSuccess={onChangeLogSuccess}
      />
      <ExportSiteReportModal
        show={showExportSiteReportModal}
        onClose={onCloseExport}
        plantId={plantId}
      />
    </>
  );
};

export default ViewSiteModals;
